import React from 'react';
import { Box, Flex, Text, Tooltip, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CodeTags } from '../../../../../constants/codes';
import { tryFormatDate } from '../../../../../utils/dateUtil';

function ItemsCell({ value: { data, total } }) {
  const requirementsWithItems = data.filter(requirement => requirement.item);
  const unitNumbers = requirementsWithItems.map(requirement => requirement.item.propertyValues?.unitNumber);
  const totalItemsCount = total - 1;

  const additionalItemsText = totalItemsCount > unitNumbers.length
    && totalItemsCount > requirementsWithItems.length
    && `... and ${totalItemsCount - requirementsWithItems.length} more`;

  return (
    <VStack
      alignItems="center"
      whiteSpace="nowrap"
    >
      {requirementsWithItems.map(requirement => (
        <Flex
          alignContent="top"
          alignItems="left"
          justifyContent="space-between"
          key={requirement.item.propertyValues?.unitNumber}
          w="200px"
        >
          <Text flexBasis="40%" mr={5}>
            {requirement.item.propertyValues?.unitNumber}
          </Text>
          <Flex
            alignContent="top"
            alignItems="left"
            flexDirection="row"
            flexWrap="wrap"
            justifyContent="flex-start"
          >
            {requirement.item.codes.map(code => {
              const text = CodeTags[code.status]
                ? CodeTags[code.status](code.letter)
                : '';
              return (
                <Tooltip
                  aria-label={tryFormatDate(code.createdAt)}
                  key={code.id}
                  label={tryFormatDate(code.createdAt)}
                >
                  <Text cursor="pointer" fontSize="md">{text}</Text>
                </Tooltip>
              );
            })}
          </Flex>
        </Flex>
      ))}
      {additionalItemsText && <Box>{additionalItemsText}</Box>}
    </VStack>
  );
}

ItemsCell.propTypes = {
  value: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({
      item: PropTypes.shape({
        codes: PropTypes.arrayOf(PropTypes.shape({
          letter: PropTypes.string
        }))
      })
    })),
    total: PropTypes.number
  })
};

export default ItemsCell;
